import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class Guid {
  static newGuid() {
    return crypto.randomUUID();
  }
}
